export const TRACK_LIFE_POLICIES_FETCHED_BACKEND_ACTION = 'track_life_policies_fetched';
export const TRACK_AVAILABLE_QUOTES_BACKEND_ACTION = 'track_available_quotes';
export const CLICKED_LINK_EVENT = 'Clicked Link';
export const SELECTED_POLICY = 'Selected policy';
export const VIEW_POLICY_DETAILS = 'View policy details';
export const TRACK_CRM_QUOTES_EVENT = 'CRM Visible Quotes';
export const TRACK_VISIBLE_QUOTES_EVENT = 'Visible Quotes';
export const VISIBLE_QUOTES_ATTRIBUTES = [
  'annualPremium',
  'carrierName',
  'coverageAmount',
  'issueType',
  'monthlyPremium',
  'name',
  'productType',
  'termInYears',
  'productUrn',
] as const;
